// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_header-module__container--2gUKr"};